import {StatusSize} from './types'

export const getSize = (size: StatusSize): string => {
  switch (size) {
    case 4:
      return 'h-4 w-4'
    case 6:
      return 'h-6 w-6'
    case 8:
      return 'h-8 w-8'
    case 10:
      return 'h-10 w-10'
    case 12:
      return 'h-12 w-12'
  }
}

export const getBackground = (
  online: boolean,
  doNotDisturb: boolean
): string => {
  if (!online) {
    return ''
  }
  if (doNotDisturb) {
    return 'bg-error'
  }
  return 'bg-success'
}
